import React, {useEffect, useRef, useState} from 'react';
import {addIdToHash, removeIdFromHash, saveCheck} from '../../functions/Global';
import CustomDialog, {CustomDialogHeaderType} from '../../global/CustomDialog';
import {t} from 'i18next';
import {ProcessEditForm} from './ProcessEditForm';
import {useAppDispatch} from '../../../redux/hooks';
import {resetMappings} from '../../../redux/slices/MappingSlice';
import {useTranslation} from 'react-i18next';
import {showMessageOnError} from '../../global/CustomToast';
import {Menu} from 'primereact/menu';
import {Button} from 'primereact/button';
import {Process} from '../../functions/GlobalData';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPen, faPlus} from '@fortawesome/free-solid-svg-icons';
import {ProcessUser} from './ProcessUser';

type Props = {
    selectedProcess?: Process,
    setSelectedProcess?: any,
    show: boolean,
    geoData: any,
    setShow: (data: boolean) => void,
    onFinished?: (data: Process) => void,
    projectId: string
}
export const ProcessDialogEditForm = (props: Props): JSX.Element => {
    const {t} = useTranslation(['common']);
    const dispatch = useAppDispatch();
    const menu = useRef<any>(null);

    const [isDirty, setIsDirty] = useState<boolean>(false);
    const [buttons, setButtons] = useState<any[]>([]);
    const [close, setClose] = useState<boolean>(false);
    const [createNew, setCreateNew] = useState<boolean>(false);
    const [duplicateNew, setDuplicateNew] = useState<boolean>(false);

    useEffect(() => {
        if (props.selectedProcess) {
            addIdToHash(props.selectedProcess.vorgang_id);
        }
    }, [props.selectedProcess]);

    useEffect(() => {
        setButtons(getButtons());
    }, [isDirty]);

    useEffect(() => {
        if (createNew) {
            setCreateNew(false);
            props.setSelectedProcess(undefined);
        }
    }, [createNew]);

    useEffect(() => {
        if (duplicateNew) {
            setDuplicateNew(false);
            props.setSelectedProcess(undefined);
        }
    }, [duplicateNew]);

    const getButtons = () => {
        let result: any[] = [];

        let items: any[] = [];

        // items.push({
        //     label: t('globalData:process.create'),
        //     icon: 'pi pi-plus',
        //     command: () => {
        //         if (isDirty) {
        //             showMessageOnError(t('globalData:toasts.saveDataFirstHeader'), t('globalData:toasts.saveDataFirstMessage'));
        //             return;
        //         }
        //         setCreateNew(true);
        //     }
        // });
        //
        // items.push({
        //     label: t('globalData:process.duplicate'),
        //     icon: 'pi pi-copy',
        //     command: () => {
        //         if (isDirty) {
        //             showMessageOnError(t('globalData:toasts.saveDataFirstHeader'), t('globalData:toasts.saveDataFirstMessage'));
        //             return;
        //         }
        //
        //         setDuplicateNew(true);
        //     }
        // });
        //
        // items.push({
        //     label: t('globalData:process.landesgeoportalLink'),
        //     icon: 'pi pi-external-link',
        //     command: () => {
        //         window.open('');
        //     }
        // });
        //
        // items.push({
        //     label: t('globalData:process.borisLink'),
        //     icon: 'pi pi-external-link',
        //     command: () => {
        //     }
        // });

        // result.push(<>
        //     <Menu model={items} popup ref={menu} id="popup_menu"/>
        //     <Button className={'p-button-text'} label={t('options')} icon="pi pi-bars"
        //             onClick={(event) => menu.current.toggle(event)}
        //             aria-controls="popup_menu" aria-haspopup/>
        // </>);

        return result;
    };

    const onCancel = () => {
        dispatch(resetMappings());
        if (props.setSelectedProcess) props.setSelectedProcess(undefined);
        if (props.setShow) props.setShow(false);
        removeIdFromHash();
    };

    return (
        <CustomDialog
            className={'edit-dialog'}
            contentClassName={'overflow-auto lg:overflow-hidden'}
            header={
                <div className={'flex'}>
                    <div className={'my-auto mr-2'}>{props.selectedProcess ?
                        <FontAwesomeIcon className="sidebar-icon" icon={faPen}/> :
                        <FontAwesomeIcon className="sidebar-icon" icon={faPlus}/>}</div>
                    <div>{t('globalData:process.singular')}</div>
                    <div>{props.selectedProcess ?
                        <ProcessUser projectId={props.projectId} id={props.selectedProcess.vorgang_id}
                                     type={'vorgang_id'}/> : undefined}</div>
                </div>}
            // headerType={props.selectedProcess ? CustomDialogHeaderType.Update : CustomDialogHeaderType.Create}
            onCancel={() => {
                if (isDirty) {
                    saveCheck(t, onCancel);
                } else {
                    onCancel();
                }
            }}
            visible={typeof props.show === 'boolean' ? props.show : false}
            customButtons={buttons}
            customButtonsBefore={true}
            maximized={true}
            buttonsInHeader={true}
            showFooter={true}
            formName={'editProcessForm'}
            onClickWithClose={() => {
                setClose(true);
            }}
        >
            <ProcessEditForm data={props.selectedProcess}
                             setIsDirty={setIsDirty}
                             onFinished={(data) => {

                                 if (close) {
                                     setClose(false);
                                     dispatch(resetMappings());
                                     props.setShow(false);
                                     if (props.setSelectedProcess) {
                                         props.setSelectedProcess(undefined);
                                     }
                                 }

                                 if (props.onFinished) {
                                     props.onFinished(data);
                                     removeIdFromHash();
                                 }
                             }} projectId={props.projectId} geodata={props.geoData}/></CustomDialog>
    );
};
